import { getLocaleKey } from "@faire/retailer-visitor-shared/serialized-data/getLocaleKey";
import { TOSType } from "@faire/retailer-visitor-shared/views/terms-of-services/data/consts";
import { getZendeskArticleData } from "@faire/retailer-visitor-shared/views/terms-of-services/data/utils";
import { getSanitizeArticleFunc, getZendeskLocale } from "@faire/web--source/common/zendesk/utils";
import { useQuery as useZendeskArticleQuery } from "@faire/web-api--source/api/zendesk/locale/articles/articleId/get-hooks";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { useQuery } from "@tanstack/react-query";
var sanitizePatterns = {
    "<p> </p>": "<br />"
};
export var useTosArticle = function(tosType) {
    var _getLocaleKey, _data_article;
    // TODO(Kim): FD-237254 Clean up post Insider AUS/CAN Expansion
    var _useQuery = useQuery({
        queryKey: [
            tosType
        ],
        queryFn: function() {
            return getZendeskArticleData(tosType);
        }
    }), zendeskData = _useQuery.data, isLoadingZendeskData = _useQuery.isPending;
    var _getLocaleKey_language, _zendeskData_linkOrId;
    var _useZendeskArticleQuery = useZendeskArticleQuery(getZendeskLocale((_getLocaleKey_language = (_getLocaleKey = getLocaleKey()) === null || _getLocaleKey === void 0 ? void 0 : _getLocaleKey.language) !== null && _getLocaleKey_language !== void 0 ? _getLocaleKey_language : Language.ENG), (_zendeskData_linkOrId = zendeskData === null || zendeskData === void 0 ? void 0 : zendeskData.linkOrId) !== null && _zendeskData_linkOrId !== void 0 ? _zendeskData_linkOrId : "", undefined, {
        enabled: tosType === TOSType.OWF_GRANT ? !!(zendeskData === null || zendeskData === void 0 ? void 0 : zendeskData.linkOrId) : true
    }), data = _useZendeskArticleQuery.data, isLoadingArticleData = _useZendeskArticleQuery.isPending;
    var _data_article_body;
    var body = getSanitizeArticleFunc(sanitizePatterns)((_data_article_body = data === null || data === void 0 ? void 0 : (_data_article = data.article) === null || _data_article === void 0 ? void 0 : _data_article.body) !== null && _data_article_body !== void 0 ? _data_article_body : "");
    return {
        body: body,
        isLoading: isLoadingZendeskData || isLoadingArticleData
    };
};
